import { render, staticRenderFns } from "./erikoistuva-laakari.vue?vue&type=template&id=04e6e616&scoped=true&"
import script from "./erikoistuva-laakari.vue?vue&type=script&lang=ts&"
export * from "./erikoistuva-laakari.vue?vue&type=script&lang=ts&"
import style0 from "./erikoistuva-laakari.vue?vue&type=style&index=0&id=04e6e616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e6e616",
  null
  
)

export default component.exports